"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flipReadonlyBitArray = void 0;
var flipReadonlyBitArray = function (rb) {
    return rb.map(function (v) { return (v === 1 ? 0 : 1); });
};
exports.flipReadonlyBitArray = flipReadonlyBitArray;
